export default function About() {
  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <div className="absolute inset-0" style={{ backgroundImage: 'linear-gradient(#e5e7eb 1px, transparent 1px), linear-gradient(90deg, #e5e7eb 1px, transparent 1px)', backgroundSize: '50px 50px' }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-center">
          <div className="lg:col-span-2">
            <div className="inline-block px-4 py-2 bg-purple-600 text-white text-xs font-semibold rounded-full mb-6 uppercase tracking-wider">
              Who We Are
            </div>
            <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Protecting Privacy<br />Since Day One
            </h2>
            <p className="text-lg text-gray-600 mb-4 leading-relaxed">
              At SURGEN S.R.L., we believe that online privacy is a fundamental right. Our mission is to provide individuals and businesses with the tools they need to protect their digital identity and maintain complete control over their personal information.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed">
              Based in Argentina, we've built our VPN service on the principles of transparency, security, and user empowerment. We don't just protect your data—we ensure it remains yours and yours alone.
            </p>
          </div>

          <div className="lg:col-span-3">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://public.readdy.ai/ai/img_res/0c69304a97b65413d56dbf3b83b602cb.jpg" 
                alt="Global Network" 
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        <div className="mt-20 bg-gradient-to-r from-blue-900 to-purple-900 rounded-2xl p-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-5xl font-bold text-white mb-2">99.9%</div>
              <div className="text-lg text-gray-300">Uptime</div>
              <div className="text-sm text-gray-400 mt-1">Reliable Connection</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-white mb-2">50+</div>
              <div className="text-lg text-gray-300">Locations</div>
              <div className="text-sm text-gray-400 mt-1">Global Servers</div>
            </div>
            <div>
              <div className="text-5xl font-bold text-white mb-2">24/7</div>
              <div className="text-lg text-gray-300">Support</div>
              <div className="text-sm text-gray-400 mt-1">Always Available</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
